export const TAX_PERCENT = 10;
